export const buildDashboardContextKey = (params: {
  route: string;
  targetId?: string | null;
  targetType?: string | null;
  teamOnly?: boolean;
  pipelineId?: string | null;
}): string | undefined => {
  if (!params.route.startsWith("/home") && !params.route.startsWith("/dashboard")) {
    return undefined;
  }

  return JSON.stringify({
    route: params.route,
    targetId: params.targetId || undefined,
    targetType: params.targetType || undefined,
    teamOnly: params.teamOnly || undefined,
    pipelineId: params.pipelineId || undefined
  });
};

export const getPopupChatHeight = (viewportHeight: number) => Math.min(Math.round(viewportHeight * 0.72), 760);
